/** Разворачивает дерево маршрутов (category/collapse) в плоский список admin-страниц. */
export function flattenAdminRoutes(routeList = []) {
  const out = [];
  for (const route of routeList) {
    if ((route.category || route.collapse) && Array.isArray(route.items)) {
      out.push(...flattenAdminRoutes(route.items));
      continue;
    }
    if (route.layout === '/admin') {
      out.push(route);
    }
  }
  return out;
}

export function findAdminRoute(routeList, pathname) {
  const adminPath = pathname.replace(/^\/admin/, '') || '/dashboard';
  const routes = flattenAdminRoutes(routeList).filter((route) => {
    const base = String(route.path || '').split('/:')[0];
    return adminPath === base || adminPath.startsWith(`${base}/`);
  });
  if (routes.length === 0) return null;
  return routes.sort(
    (a, b) => String(b.path || '').length - String(a.path || '').length
  )[0];
}
